export const capPhoneDigits = (value, max = 10) => {
  let digitCount = 0;
  let out = '';
  for (const ch of value) {
    if (ch >= '0' && ch <= '9') {
      if (digitCount >= max) continue;
      digitCount++;
    }
    out += ch;
  }
  return out;
};

export const wirePhoneCap = (input, max = 10) => {
  input.addEventListener('input', () => {
    const capped = capPhoneDigits(input.value, max);
    if (capped === input.value) return;
    const pos = input.selectionStart;
    input.value = capped;
    try {
      input.setSelectionRange(pos, pos);
    } catch (_) {
      // some input types don't support selection APIs
    }
  });
};
